import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { ChangeDetectionStrategy } from '@angular/core';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { ConfirmationDialogEspecial } from '../confirmation-dialog/confirmation-dialog-especial.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

declare const Rut: any;
declare const ageCalculator: any;

export interface DialogData {
  rut: any,
  dv: any,
  termino: any,
  motivo: string,
  fechaDesafiliacion: any
  tiposRazones: any
  fechaRechazo: any
  otro: boolean
  tipoSistema: any
  tipoRazon: any
  scales: boolean
  fechaActual: string
}

@Component({
  selector: 'app-solicitar-desafiliar-afiliacion',
  templateUrl: '../../pages/afiliacion/dialog-solicitar-desafiliar-afiliacion.component.html',
  styleUrls: ['../../pages/solicitud-afiliacion/solicitud-afiliacion.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DialogSolicitarDesafiliarAfiliacionComponent implements OnInit, OnDestroy {

  nombreUsuario: string = localStorage.getItem("nombreUsuario")
  rutAfiliado: string = localStorage.getItem("rutAfiliado")
  idEjecutivo = localStorage.getItem("idUsuario")
  rutUsuario: any;
  randomString: string;
  tiposRazones: any;
  fechaRechazo: any;
  motivo: string;
  termino: any;
  rut: any;
  mostrarDatosCargados: boolean;
  cursos: any[]; postulantes: any[];
  afiliado: any = { rut: "", sub: "", name: "", nombres: "", idAfiliado: '', email: '', nombreAfiliado: '', apellidoAfiliado: '' };

  constructor(private router: Router,
    public dialogRef: MatDialogRef<DialogSolicitarDesafiliarAfiliacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog,
    private postulacionesService: PostulacionesService,
    private afiliacionService: AfiliacionService) {
    let vm = this
    vm.data.termino = false
    // Obtiene la fecha actual en el formato yyyy-MM-dd
    vm.data.fechaActual = new Date().toISOString().slice(0, 10);
    this.afiliacionService.getRazonesDesafiliar().then(
      tiposRazones => this.data.tiposRazones = tiposRazones
    ).catch(error => console.log(error))
  }

  ngOnInit(): void {
  }


  ngOnDestroy(): void {
  }



  casoExitoso() {
    this.router.navigate(['/login'])
  }
  casoFallido() {
    this.router.navigate(['/solicitud-afiliacion'])
  }


  onDesafiliarAfiliado(form: NgForm) {
    let vm = this;
    vm.termino = false
    if (!form.form.value.fechaDesafiliacion) {
      this.openAlertDialog('Debe ingresar la fecha de desafiliacion', 'btn-danger')
      return false
    }

    if (!form.form.value.tipoRazon || form.form.value.tipoRazon == -1) {
      this.openAlertDialog('Debe ingresar una razón de desafiliacion', 'btn-danger')
      return false
    }

    if (!vm.data.scales) {
      this.openAlertDialog('Solo se puede aceptar la solicitud de Desafiliación en caso que sean aceptados los Términos y Condiciones.', 'btn-danger')
      return false;
    }

    if (vm.data.otro && !form.form.value.motivo) {
      this.openAlertDialog('Debe ingresar OTRO motivo de desafiliación', 'btn-danger')
      return false
    }

    let fechaDesafiliacionTemp = ''
    if (form.form.value.fechaDesafiliacion) {
      fechaDesafiliacionTemp = form.form.value.fechaDesafiliacion.split('-')[2] + '-' + form.form.value.fechaDesafiliacion.split('-')[1] + '-' +
        form.form.value.fechaDesafiliacion.split('-')[0]
    } else {
      vm.openAlertDialog('El campo fecha de afiliación no debe ir vacio', 'btn-danger')
      return false;
    }


    const dialogRef = this.dialog.open(ConfirmationDialogEspecial, {
      data: {
        message: '¿Esta seguro de desafiliarse?'
        , botonStyleCancel: "margin-left:20%;"
        , botonStyleAceptar: "margin-left:5%;"
        , buttonText: { ok: 'Si', cancel: 'No' }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          text: 'Cargando...'
        });
        Swal.showLoading();
        this.aprobarDesafiliacionAfiliado(vm.data.rut)

        this.afiliacionService.pendienteDesafiliacion(vm.data.rut, form.form.value.motivo, form.form.value.tipoRazon, vm.idEjecutivo).then
          (
            response => {
              Swal.close();
              this.dialogRef.close()
              vm.termino = true
              vm.data.termino = true
              this.onDesafiliarEnviarClave(form)
              //this.aprobarDesafiliacionAfiliado(vm.data.rut)


            }
          )
          .catch
          (
            () => {
              this.onDesafiliarEnviarClave(form)
              //this.aprobarDesafiliacionAfiliado(vm.data.rut)
              Swal.close();
            }
          )

      }
    })
  }



  aprobarDesafiliacionAfiliado(rut: any) {
    let vm = this;

    this.afiliacionService.aprobarDesafiliacionAfiliado(rut).then
      (
        response => {
          Swal.close();
        }
      )
      .catch
      (
        () => {
          Swal.close();
        }
      )
  }




  onDesafiliarEnviarClave(form: NgForm) {



    this.randomString = this.generateRandomString(300);
    localStorage.setItem("solicitudDesafiliacion", "true");
    let vm = this
    document.location.href = `${environment.urlClaveUnica}` + "openid/authorize/" +
      "?client_id=" + `${environment.clienteId}` +
      "&response_type=code" +
      "&scope=openid run name" +
      "&redirect_uri=" + `${environment.claveRedirectUri}` +
      "&state=" + this.randomString;

  }
  generateRandomString(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      result += characters.charAt(randomIndex);
    }
    return result;
  }

  muestraOtro() {
    let vm = this
    vm.data.otro = false;
    vm.data.tipoSistema = 0
    for (let i = 0; i < this.data.tiposRazones.length; i++) {

      if (vm.data.tiposRazones[i].descripcion == 'Otros') {
        vm.data.tipoSistema = this.data.tiposRazones[i].id;
      } else {
        vm.data.tipoSistema = 0
      }
    }
    if (vm.data.tipoRazon == vm.data.tipoSistema) {
      vm.data.otro = true;
    }

  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  onCancelarClick(): void { this.dialogRef.close() }
}
